import React, { useEffect, useState } from "react";  
import styles from "./ChatArea.module.css";  
import {storeBatabotCallRating} from "../../services/survey.service";
  
const ChatArea = ({email, firstName, noHandler, view, setView, error, callStatus, setCallStatus, startCallHandler}) => {  
  const [audioLevels, setAudioLevels] = useState(Array(10).fill(5)); // 10 waves  

  const [showThankYou, setshowThankYou] = useState(false); // 10 waves  
  
  const handleClick = () => {  
    setView("initial");  
  };  
  
  const handleYesClick = () => {  
    setView("expanded");  
    setCallStatus("pending");
    startCallHandler();
  };  

  const [hoveredStar, setHoveredStar] = useState(0); // Tracks star being hovered  
  const [selectedStar, setSelectedStar] = useState(0); // Tracks selected star  
  
  const handleStarClick = (star) => {  
    if(!showThankYou){
      setshowThankYou(true);
      setSelectedStar(star);  
      console.log(star);
      storeBatabotCallRating({'email': email, 'service': 'batabot-new-office', 'context': {'rating': star}, 'datetime': new Date()})
      .then(() => {
        console.log('rated correctly');
      });
    }
  };  
  
  const handleStarHover = (star) => {  
    setHoveredStar(star);  
  };  
  
  const handleStarLeave = () => {  
    setHoveredStar(0);  
  }; 
  
  return (  
    <>  
      {view === "expanded" && (  
        <div className={styles.initialContainer} onClick={handleClick}>  
          <div className={styles.roundVisualizer}>  
            <div className={styles.voiceVisualizer} id="voiceVisualizer">  
              {audioLevels.map((level, i) => (  
                <div  
                  key={i}  
                  className={styles.wave + " wave-ai"}  
                  style={{ height: `${level}px` }}  
                ></div>  
              ))}  
            </div>  
          </div>  
        </div>  
      )}
      {callStatus == "pending" && <div className={styles.expandedContainer}> Loading... </div>}  
      {error !== null && <div className={styles.expandedContainer}> {error}. Porfavor recarga la página. </div>}  

      {view === "final" && (  
        <div className={styles.expandedContainer}>  
          <p>Este es el final de la llamada <br/> ¿Cómo fue la experiencia?</p>  
          
          <div  
            className={styles.ratingContainer}  
            onMouseLeave={handleStarLeave}  
          >  
            {[1, 2, 3, 4, 5].map((star) => (  
              <span  
                key={star}  
                className={`${styles.star} ${  
                  star <= (hoveredStar || selectedStar)  
                    ? styles.activeStar  
                    : styles.inactiveStar  
                }`}  
                onMouseEnter={() => handleStarHover(star)}  
                onClick={() => handleStarClick(star)}  
              >  
                ★  
              </span>  
            ))}  
          </div>  
          {showThankYou && (  
            <p className={styles.thankYouMessage}>Gracias por tu reseña</p>  
          )}  
        </div>  
      )}  
  
      {(view === "initial" || view === "chat") && (  
        <div className={styles.expandedContainer}>  
        {view == "chat" && (  
          <div className={styles.voiceSection}>  
            <div className={styles.voiceVisualizer} id="voiceVisualizer">  
              {audioLevels.map((level, i) => (  
                <div  
                  key={i}  
                  className={styles.wave}  
                  style={{ height: `${level}px` }}  
                ></div>  
              ))}  
            </div>  
          </div>)  
        }
  
          <div className={styles.cameraPermission}>  
            <div className={styles.iconContainer}>  
              <span className={" material-symbols-rounded"} style={{fontSize: "80px"}}>support_agent</span>
            </div>  
            <p className={styles.permissionText}>  
              Hola, {firstName}! <br/> ¿Tienes alguna pregunta que pueda ayudarte sobre el cambio de oficina?
            </p>  
            <div className={styles.buttons}>  
              <button className={styles.yesButton} id="btn-toggle-stream" onClick={handleYesClick}>SI</button>  
              <button className={styles.noButton} onClick={noHandler}>  
                NO  
              </button>  
            </div>  
          </div>  
        </div>  
      )}  

    </>  
  );  
};  
  
export default ChatArea;  